<template>
  <div class="quote__policy">
    <div class="quote__policy-header">
      <div class="quote__policy-top">
        <div class="quote__title">{{ $t('qic_quote_ph_contacts') }}</div>
      </div>
      <ul class="quote__policy-list">
        <li> {{ email }} </li>
        <li> {{ phone }} </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuotePolicyHolder',
  props: {
    email: { type: String, default: 'No email' },
    phone: { type: String, default: 'No phone' }
  }
}
</script>
